import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { SelectedNodesProvider } from '@/features/connect-dots/contexts/SelectedNodesProvider';
import { TagViewContainer } from '../components/containers/TagViewContainer';
import { FilterMirrorContainer } from '../components/containers/FilterMirrorContainer';
import { FilterButtons } from '../components/visualizer/FilterButtons';

export const TagViewDialog = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();

  const title = t('RuleWatcherタグを探索し、選択する');

  // サイドバー
  const sidebarContent = <FilterMirrorContainer />;

  // メインコンテンツ
  const mainContent = <TagViewContainer />;

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      {/* グレーの半透明オーバーレイ */}
      <div className="fixed inset-0 bg-black/20" aria-hidden="true" />
      <div
        className="fixed inset-0 flex items-center justify-center p-4"
        aria-hidden="true"
      >
        <SelectedNodesProvider>
          <DialogPanel className="relative size-full max-w-7xl overflow-y-hidden rounded-lg bg-white shadow-lg">
            {/* ヘッダー */}
            <div className="flex items-center justify-between border-b p-6">
              <DialogTitle className="text-xl font-semibold">
                {title}
              </DialogTitle>
              <FilterButtons onClose={onClose} />
            </div>

            {/* メインコンテンツエリア */}
            <div className="flex size-full">
              {/* サイドバー */}
              <div className="h-full shrink-0 border-r bg-gray-200">
                {sidebarContent}
              </div>

              {/* メインコンテンツ */}
              <div className="w-full flex-1 p-1">{mainContent}</div>
            </div>
          </DialogPanel>
        </SelectedNodesProvider>
      </div>
    </Dialog>
  );
};
